'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "side"];
import * as React from 'react';
import { useStableCallback } from '@base-ui/utils/useStableCallback';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { useEventResizeHandler } from "../../internals/utils/useEventResizeHandler.mjs";
import { useCalendarGridTimeEventContext } from "../time-event/CalendarGridTimeEventContext.mjs";
export const CalendarGridTimeEventResizeHandler = /*#__PURE__*/React.forwardRef(function CalendarGridTimeEventResizeHandler(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      side
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);

  // Context hooks
  const contextValue = useCalendarGridTimeEventContext();

  // Ref hooks
  const ref = React.useRef(null);

  // Feature hooks
  const getDragData = useStableCallback(input => _extends({}, contextValue.getSharedDragData(input), {
    source: 'CalendarGridTimeEventResizeHandler',
    side
  }));
  const {
    state,
    enabled
  } = useEventResizeHandler({
    ref,
    side,
    contextValue,
    getDragData
  });
  return useRenderElement('div', componentProps, {
    enabled,
    state,
    ref: [forwardedRef, ref],
    props: [elementProps]
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridTimeEventResizeHandler.displayName = "CalendarGridTimeEventResizeHandler";